<template>
  <div class="app-wrapper">
    <navbar />
    <div class="main-container">
      <el-container class="container">
        <el-aside class="aside-bar">
          <sidebar v-if="getUserInfo" class="sidebar-container" />
        </el-aside>
        <div v-if="getUserInfo" class="main-content">
          <Breadcrumb v-show="$route.meta.title" />
          <div class="main-view">
            <transition name="fade-transform" mode="out-in">
              <slot />
            </transition>
          </div>
        </div>
      </el-container>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, Breadcrumb } from './components'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    Breadcrumb
  },
  data() {
    return {
      getUserInfo: false
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ])
  },
  async created() {
    await this.getCurrentUser()
    this.getUserInfo = true
  },
  methods: {
    ...mapActions([
      'getCurrentUser'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/mixin.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100vh;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.main-container {
  height: 100%;
  padding-top: $header_height;
  box-sizing: border-box;
}

.container {
  height: 100%;
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.aside-bar {
  flex: 0 0 210px;
}

.main-content {
  height: calc(100vh - #{$header_height});
  flex: 1;
  overflow-y: scroll;
}

.main-view {
  // padding: 0 10px;
}

// 动画
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
